import $ from 'jquery';

export function ShowAlert(title, message) {
  $('#modal-alert .modal-title').html(title);
  $('#modal-alert .modal-body').html(
    '<i className="fa fa-info-circle fa-fw text-gray"></i> ' + message,
  );
  window.$('#modal-alert').modal('show');
}
